import { render, staticRenderFns } from "./showPartnersViews.vue?vue&type=template&id=518617ba"
import script from "./showPartnersViews.vue?vue&type=script&lang=js"
export * from "./showPartnersViews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports